export const VIDEO_DOMAIN = "http://video.kleinbuendel.com/bsmart/";
